import { SSO_LOGIN_METHODS } from 'consts';
import { Oauth } from 'components/shared';

export const OauthAzure = () => <Oauth method={SSO_LOGIN_METHODS.azure} />;
